import { render } from "./MultisidebarContentNotFound.vue?vue&type=template&id=d94a5efa&ts=true"
import script from "./MultisidebarContentNotFound.vue?vue&type=script&lang=ts"
export * from "./MultisidebarContentNotFound.vue?vue&type=script&lang=ts"

import "./MultisidebarContentNotFound.vue?vue&type=style&index=0&id=d94a5efa&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__